<template>
    <v-container>
        <v-card>
            <v-card-text>
                <div class="text-center text-h4">
                    Please Enter Your Password
                </div>
                <v-row>
                    <non-form-field-errors :errors="errors"></non-form-field-errors>
                    <v-col cols="12">
                        <v-text-field :error-messages="errors.password1" type="password" v-model="password1"
                                      label="New Password">

                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field :error-messages="errors.password2" v-model="password2" type="password"
                                      label="Confirm Password">

                        </v-text-field>
                    </v-col>
                    <v-col offset-md="4" md="4">
                        <v-btn @click="submit" block large color="primary">Save</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    import {Form} from "../utils/form";
    import NonFormFieldErrors from "../components/utils/errors/NonFormFieldErrors";

    export default {
        name: "PasswordCreate",
        components: {NonFormFieldErrors},
        data() {
            return {
                password1: "",
                password2: "",
                errors: {}
            }
        },
        methods: {
            submit() {
                let form = new Form({
                    password1: this.password1,
                    password2: this.password2,
                })
                form.post(apiRoutes.auth.createPassword.url + "/" + this.$route.params.token).then(response => {
                        localStorage.removeItem("auth_token")
                        this.$router.replace({name: "login"})
                }).catch(error => {
                    if (error.status === 400) {
                        this.errors = error.data
                    } else {
                        this.errors = {
                            non_field_errors: ["Invalid Link"]
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>